module.exports = __webpack_public_path__ + "img/symbol_17.d22bacc1.png";